<div class="card">
    <div class="card-header pt-1 pb-1 bg-info ">
        <h5 class="mt-2 text-white text-center">Müşteri Bakiyeleri</h5>
    </div>
    <div class="p-3 d-flex">
        <div class="input-group me-2">
            <input type="text" placeholder="Müşteri Adı" class="form-control form-control-sm" (keyup)="filterToList()"
                [(ngModel)]="filter.customerName">
        </div>
        <div class="input-group me-2">
            <select class="form-control form-control-sm" [(ngModel)]="filter.currency" (change)="setSubTypes()">
                <option [ngValue]="defaultValue">Birim</option>
                <option *ngFor="let currency of currencyList" [ngValue]="currency"> {{currency | customCurrency}}
                </option>
            </select>
        </div>
        <div class="input-group me-2">
            <select class="form-control form-control-sm" [(ngModel)]="filter.subType" (change)="filterToList()">
                <option [ngValue]="defaultValue">Alt Birim</option>
                <option *ngFor="let subType of subTypeList" [ngValue]="subType"> {{subType | subTypeDisplay}} </option>
            </select>
        </div>
    </div>
    <div class="vertical-container" *ngIf="filterableList.length != 0">
        <div class="scrollbar" id="scrollbar1">
            <table class="table table-hover table-bordered">
                <thead class="table-light sticky-top">
                    <tr>
                        <th>Cari</th>
                        <ng-container *ngFor="let listItem of currencyList; let headerIndex = index">
                            <th>{{listItem | customCurrency}}</th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let listItem of showedList; let headerIndex = index">
                        <td>
                            <div class="d-flex align-items-center justify-content-between">
                                <a routerLink="/customer/detail/{{listItem.customerId}}" href="javascript: void(0);"
                                class="text-link" triggers="hover" ngbTooltip="Müşteriye git"><i
                                    class="fas fa-user-tie me-2"></i> {{listItem.customerName}}</a>
                                    
                                <button class="btn btn-sm btn-danger" triggers="hover" ngbTooltip="Yazdır"
                                    (click)="goToLink('/receipts/customer-balance?id='+ listItem.customerId)"> <i class="fas fa-print"></i></button>
                            </div>
                        </td>
                        <ng-container *ngFor="let currency of currencyList; let headerIndex = index">
                            <td class="text-center">
                                <ng-container *ngFor="let customerBalance of listItem.customerBalances; let headerIndex = index">
                                    <div class="mb-2" *ngIf="customerBalance.currency == currency">
                                        <div *ngIf="customerBalance.balance < 0">
                                            <span class="fs-6 badge rounded-pill p-2 badge-soft-danger d-flex align-items-center justify-content-between" >
                                                <div>
                                                    {{customerBalance.balance | currencyAmount}}
                                                    <span *ngIf="customerBalance.subType != undefined">{{customerBalance.subType | subTypeDisplay}}</span>
                                                </div>
                                                <a href="javascript:void(0)" (click)="openFastCollectionModal(customerBalance, true)" class="text-danger"><i class="fas fa-times"></i></a>
                                            </span>    
                                        </div>
                                        <div *ngIf="customerBalance.balance > 0">
                                            <span class="fs-6 badge rounded-pill p-2 badge-soft-success d-flex align-items-center justify-content-between" >
                                                <div>
                                                    {{customerBalance.balance | currencyAmount}}
                                                    <span *ngIf="customerBalance.subType != undefined">{{customerBalance.subType | subTypeDisplay}}</span>
                                                </div>
                                                <a href="javascript:void(0)" (click)="openFastCollectionModal(customerBalance, false)" class="text-success"><i class="fas fa-times"></i></a>
                                            </span>
                                            

                                        </div>
                                    </div>
                                </ng-container>
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>